const $doc = $(document);
const $note = $('.js-note');

$doc.on('submit', $note.closest('form'), function(e) {
  const $this = $(this);
  let fieldText = '';

  $this
    .find('.js-note-field')
    .each(function() {
      const $field = $(this);
      const placeholder = $field.attr('placeholder');
      const fieldVal = $(this).val();

      if (fieldVal != '') {
        fieldText += `${placeholder}: ${fieldVal} \n`
      };
    });

  $this.find('.js-note-textarea').val(fieldText)
});



// WEBPACK FOOTER //
// ../assets/js/note.js